import * as React from "react";
import { Routes, Route, /*Router, Switch*/ } from "react-router-dom";
import {Home} from './components/Home'
import {/*About, Dashboard,*/ NoMatch} from './components/Other'
import {Layout} from './components/Layout/Main'
import { basename/*, history*/ } from './utils';
//import { Helmet } from "react-helmet";

export default function App() {
  return (
    <div>
        {/* <Router history={history}>
                <div className='app'>
                    <Helmet>
                        <base href={`/${basename}/`} />
                    </Helmet>
                    <Switch>
                        <Route path='/' component={Home} />
                        <Route path="*" component={<NoMatch />} />
                    </Switch>
                </div>
            </Router> */}
      <Routes>
        <Route  path={`${basename}/`} element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </div>
  );
}



